import { useFormik } from 'formik';
import { Hooks } from 'providers';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'components/_parts/atoms/ReactQuillWrapper';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAddBoardMutation, useUpdateBoardMutation } from 'components/board/hooks/useBoard';
import * as Yup from 'yup';

type Props = {
  data: string[];
  extension: boolean;
};

function FormBoard(props: any) {
  const { t }: { t: (value: string) => string } = useTranslation();
  const history = useHistory();

  const { modalAdd, setModal, setModalAdd } = useContext(Hooks);
  const addBoardMutation = useAddBoardMutation();
  const updateBoardMutation = useUpdateBoardMutation();
  const formik = useFormik({
    initialValues: {
      name: props.data?.name || '',
      description: props.data?.description || '',
      visibility_status: '',
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .typeError('Must string')
        .required(t('org.employee.form.field_cannot_empty')),
    }),
    onSubmit: async (values, { resetForm }) => {
      // throw Error;
      setModalAdd(false);
      setModal(false);
      if (props.extension) {
        await updateBoardMutation.mutateAsync({
          board_id: props.data?.board_id,
          name: formik.values.name,
          description: formik.values.description,
          visibility_status: formik.values.visibility_status ? '1' : '0',
        });
      } else {
        await addBoardMutation.mutateAsync({
          name: formik.values.name,
          description: formik.values.description,
          visibility_status: formik.values.visibility_status ? '1' : '0',
          publish_status: '0',
        });
      }
      void formik.setValues({
        name: '',
        description: '',
        visibility_status: '',
      });
      resetForm();
      history.push('/board');
    },
  });
  useEffect(() => {
    if (props.extension === false) {
      formik.setValues({
        name: '',
        description: '',
        visibility_status: '',
      });
    }
  }, [modalAdd]);

  return (
    <form onSubmit={() => formik.handleSubmit()}>
      <div className="form-group">
        <label>{t('board.name')}</label>
        {!props.extension ? (
          <input
            className="form-control form-control-lg"
            type="text"
            id="name"
            onChange={formik.handleChange}
            value={formik.values.name}
            name="name"
            placeholder={t('board.enter_board_name')}
          />
        ) : (
          <input
            className="form-control form-control-lg"
            type="text"
            id="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            name="name"
            placeholder={t('board.enter_board_name')}
          />
        )}

        {formik.touched.name && formik.errors.name ? (
          <span className="error">{formik.errors.name}</span>
        ) : null}
      </div>
      <div className="form-group">
        <label htmlFor="desc">{t('board.desc')}</label>
        {!props.extension ? (
          <>
            {/* <EditorToolbar /> */}
            <ReactQuill
              id="desc"
              theme="snow"
              className="rCardShortdesc"
              name={'description' ?? ''}
              onChange={(e) => formik.setValues({
                ...formik.values,
                description: e,
              })}
              value={formik.values.description}
              placeholder={t('board.board_desc')}
            />
          </>
        ) : (
          <ReactQuill
            theme="snow"
            name="description"
            className="rCardShortdesc"
            onChange={(e) => formik.setValues({
              ...formik.values,
              description: e,
            })}
            defaultValue={
              props.extension
                ? props.data?.description
                : formik.values.description
            }
            placeholder={t('board.board_desc')}
          />
        )}
        {formik.touched.description && formik.errors.description ? (
          <span className="error">{formik.errors.description as string}</span>
        ) : null}
      </div>
      <div className="text-center mt-3 col-md-3 float-right">
        <button
          className="btn btn-lg btn-primary bt100 btnRprim"
          type="submit"
          onClick={(e) => {
            formik.handleSubmit(e);
          }}
        >
          {t('board.submit')}
        </button>
      </div>
    </form>
  );
}

export default FormBoard;
